import React, { Component } from 'react'
import '../../App.css'

import {Consumer} from '../../context';
import Spinner from '../Layouts/Spinner';
import Track from '../Tracks/Track';

export default class Tracks extends Component {
    render() {
        return (
            <Consumer>
                {value => {
                    const {track_list_in, heading} = value;
                    if((track_list_in === undefined || track_list_in.length === 0))
                    {
                        return <Spinner/>
                    } else {
                        return(
                            <React.Fragment>
                                <h3 className="text-center" style={{fontFamily: 'Source Sans Pro', marginTop: 20, marginBottom: 20}}>{heading}</h3>
                                <div className="row">
                                    {track_list_in.map(item => (
                                        <Track key={item.track.id} track={item.track}/>
                                    ))}
                                </div>
                            </React.Fragment>
                        )
                    }
                }}
            </Consumer>
        )
    }
}
